import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { queryAnnualTaxInfo } from "./services";

export function annualTaxLoader() {
  return defer({
    coreData: resolveLoaderResult(queryAnnualTaxInfo()),
  });
}
